import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { PlanillaPartidoEnVivo, PlanillaPartidoEnVivoJSON } from './PlanillaPartidoEnVivo';

export class PlanillaPartidoEnVivoSystem {
  private readonly base = '/planilla-partido-en-vivo';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getPlanillaPartidoEnVivoIdentifiedBy(id: string): Promise<PlanillaPartidoEnVivo> {
    const data = await this.requestHandler.get<PlanillaPartidoEnVivoJSON>(`${this.base}/${id}`);
    return PlanillaPartidoEnVivo.fromJSON(data);
  }

  async getList(): Promise<PlanillaPartidoEnVivo[]> {
    const data = await this.requestHandler.get<PlanillaPartidoEnVivoJSON[]>(`${this.base}`);
    return data.map((entity) => PlanillaPartidoEnVivo.fromJSON(entity));
  }

  async getListForDropdown(): Promise<PlanillaPartidoEnVivo[]> {
    const data = await this.requestHandler.get<PlanillaPartidoEnVivoJSON[]>(`${this.base}/for-dropdown`);
    return data.map((entity) => PlanillaPartidoEnVivo.fromJSON(entity));
  }

  async save(entity: PlanillaPartidoEnVivo) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<PlanillaPartidoEnVivoJSON, PlanillaPartidoEnVivoJSON>(
      this.base,
      data
    );
    return PlanillaPartidoEnVivo.fromJSON(savedEntity);
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }
}
